import { LogLevel } from '@azure/msal-browser';
import configData from './config.json';

export const msalConfig = {
  auth: {
    knownAuthorities: [configData.REACT_APP_B2C_TENANT_ID],
    // redirectUri: '/',
    redirectUri: `${window.location.origin}/`,
    // postLogoutRedirectUri: 'window.location.origin',
    // navigateToLoginRequestUrl: 'true',
    clientId: configData.REACT_APP_B2C_CLIENTID,
    authority: configData.REACT_APP_B2C_AUTHORITY,
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: window.location.origin
    // validateAuthority: false
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.log(message);
        }
      }
    }
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [configData.REACT_APP_B2C_READ_SCOPE]
};

export const loginRequestJobs = {
  state: 'page_url=jobs',
  scopes: [configData.REACT_APP_B2C_READ_SCOPE]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};
